import { memo, forwardRef } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Col, Grid } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'
import { InviteGuard } from 'views/subdelegated/invite-guard'

import { SubdelegatedRegistrationForm } from './form'
import * as S from './styles'

const Registration = memo(
  forwardRef<HTMLElement, {}>(({}, ref) => {
    const { isMobile } = useWindowSize()
    return (
      <S.Registration ref={ref}>
        <Grid col={{ phone: 1, tablet: 2, desktop: 12 }} gap={{ phone: 'xxxl' }}>
          <Col col={{ phone: 1, tablet: 1, desktop: 6 }} start={{ desktop: 2 }}>
            {isMobile ? (
              <></>
            ) : (
              <S.WrapperPolygon>
                <NextImage
                  src={process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX + '/site/substabelecido/triangle.svg'}
                  width="897"
                  height="1078"
                  alt=""
                  aria-hidden="true"
                />
              </S.WrapperPolygon>
            )}
            <S.TitleWrapper>
              <Text as="h1" size="heading1" weight="medium">
                Seja um Parceiro {isMobile ? <></> : <br />}e {''}
                <Text as="span" size="heading1" weight="medium" color="var(--colors-pink-text-default)">
                  impulsione o {isMobile ? <></> : <br />}
                  seu negócio
                </Text>
              </Text>
            </S.TitleWrapper>
          </Col>
          <Col col={{ phone: 1, tablet: 1, desktop: 5 }}>
            <S.WrapperRegistration>
              <S.InviteGuardWrapper>
                <InviteGuard>
                  {({ email, lpDocument, code }) => (
                    <SubdelegatedRegistrationForm email={email} lpDocument={lpDocument} code={code} />
                  )}
                </InviteGuard>
              </S.InviteGuardWrapper>
            </S.WrapperRegistration>
          </Col>
        </Grid>
      </S.Registration>
    )
  })
)

Registration.displayName = 'Registration'

export default Registration
